// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================= */
/* RESET HELPERS */
/* ============================= */
a {
  text-decoration: none;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* ============================= */
/* TOP HEADER */
/* ============================= */
.top-header-wrapper {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
  z-index: 1000;
}

.top-header-inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  height: 72px;
}

.top-actions {
  justify-self: end;
}

.top-center {
  display: flex;
  align-items: center;
  gap: 24px;
}

/* ============================= */
/* LOGO */
/* ============================= */
.navbar-brand img.logo {
  height: 36px;
  width: auto;
}

.top-nav {
  display: flex;
  gap: 28px;
  align-items: center;
}

.top-nav a,
.top-nav .nav-link {
  font-size: 18px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

.top-nav a:hover,
.top-nav .nav-link:hover {
  color: #034EA2;
}

/* ============================= */
/* RIGHT ACTIONS */
/* ============================= */
.top-actions {
  display: flex;
  align-items: center;
  gap: 18px;
}

/* ============================= */
/* CONTACT BUTTON */
/* ============================= */
.contact-btn {
  border: 1.5px solid #034EA2;
  padding: 8px 18px;
  border-radius: 6px;
  color: #034EA2;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.contact-btn:hover {
  background: #034EA2;
  color: #ffffff;
}

/* ============================= */
/* SEARCH */
/* ============================= */
.search.desktop {
  position: relative;
}

.search-input {
  width: 260px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 0 12px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #034EA2;
}

/* ============================= */
/* SEARCH DROPDOWN */
/* ============================= */
.search-dropdown {
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  max-height: 260px;
  overflow-y: auto;
  z-index: 9999;
}

.search-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
  font-size: 14px;
  color: #111827;
  border-bottom: 1px solid #f1f5f9;
}

.search-item:hover {
  background: #f8fafc;
}

.search-item small {
  font-size: 12px;
  color: #6b7280;
}

.no-result {
  padding: 14px;
  text-align: center;
  font-size: 14px;
  color: #6b7280;
}

/* ============================= */
/* INDUSTRY DROPDOWN */
/* ============================= */
.industry-dropdown {
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

.industry-dropdown .container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  padding: 18px 0;
}

.industry-dropdown a {
  font-size: 14px;
  color: #374151;
}

.industry-dropdown a:hover {
  color: #034EA2;
}

/* ============================= */
/* MOBILE NAV BAR */
/* ============================= */
.mobile-nav {
  display: none;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 10px 0;
}

.mobile-nav img {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

/* ============================= */
/* MOBILE SEARCH */
/* ============================= */
.mobile-search {
  position: fixed;
  inset: 0;
  background: #ffffff;
  z-index: 9999;
  padding: 20px;
}

.mobile-search input {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 0 14px;
  font-size: 15px;
}

/* ============================= */
/* REMOVE BODY SCROLL */
/* ============================= */
.remove-scrolling {
  height: 100%;
  overflow: hidden;
}

/* ============================= */
/* RESPONSIVE */
/* ============================= */
@media (max-width: 992px) {
  .top-nav {
    display: none;
  }

  .search.desktop {
    display: none;
  }

  .contact-btn {
    display: none;
  }

  .mobile-nav {
    display: block;
  }
}


/* ================= MOBILE HEADER FIX ================= */

.mobile-actions {
  display: none;
  gap: 14px;
  align-items: center;
}

.icon-btn {
  height: 26px;
  width: 26px;
  cursor: pointer;
}

/* Hide desktop-only items on mobile */
.desktop-only {
  display: inline-flex;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 992px) {
  .top-center {
    display: none;
  }

  .contact-btn.desktop-only {
    display: none;
  }

  .mobile-actions {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/topHeader.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,kBAAkB;AAClB,kCAAkC;AAClC;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,kCAAkC;AAClC,eAAe;AACf,kCAAkC;AAClC;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kCAAkC;AAClC,SAAS;AACT,kCAAkC;AAClC;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,kCAAkC;AAClC,kBAAkB;AAClB,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kCAAkC;AAClC,mBAAmB;AACnB,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC,WAAW;AACX,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC,oBAAoB;AACpB,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC,sBAAsB;AACtB,kCAAkC;AAClC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC,mBAAmB;AACnB,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA,kCAAkC;AAClC,kBAAkB;AAClB,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC;AAClC,uBAAuB;AACvB,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC,eAAe;AACf,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,0DAA0D;;AAE1D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================= */\r\n/* RESET HELPERS */\r\n/* ============================= */\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n/* ============================= */\r\n/* TOP HEADER */\r\n/* ============================= */\r\n.top-header-wrapper {\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  position: relative;\r\n  z-index: 1000;\r\n}\r\n\r\n.top-header-inner {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: center;\r\n  height: 72px;\r\n}\r\n\r\n.top-actions {\r\n  justify-self: end;\r\n}\r\n\r\n.top-center {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 24px;\r\n}\r\n\r\n/* ============================= */\r\n/* LOGO */\r\n/* ============================= */\r\n.navbar-brand img.logo {\r\n  height: 36px;\r\n  width: auto;\r\n}\r\n\r\n.top-nav {\r\n  display: flex;\r\n  gap: 28px;\r\n  align-items: center;\r\n}\r\n\r\n.top-nav a,\r\n.top-nav .nav-link {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  cursor: pointer;\r\n}\r\n\r\n.top-nav a:hover,\r\n.top-nav .nav-link:hover {\r\n  color: #034EA2;\r\n}\r\n\r\n/* ============================= */\r\n/* RIGHT ACTIONS */\r\n/* ============================= */\r\n.top-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n}\r\n\r\n/* ============================= */\r\n/* CONTACT BUTTON */\r\n/* ============================= */\r\n.contact-btn {\r\n  border: 1.5px solid #034EA2;\r\n  padding: 8px 18px;\r\n  border-radius: 6px;\r\n  color: #034EA2;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.contact-btn:hover {\r\n  background: #034EA2;\r\n  color: #ffffff;\r\n}\r\n\r\n/* ============================= */\r\n/* SEARCH */\r\n/* ============================= */\r\n.search.desktop {\r\n  position: relative;\r\n}\r\n\r\n.search-input {\r\n  width: 260px;\r\n  height: 38px;\r\n  border-radius: 6px;\r\n  border: 1px solid #d1d5db;\r\n  padding: 0 12px;\r\n  font-size: 14px;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #034EA2;\r\n}\r\n\r\n/* ============================= */\r\n/* SEARCH DROPDOWN */\r\n/* ============================= */\r\n.search-dropdown {\r\n  position: absolute;\r\n  top: 44px;\r\n  left: 0;\r\n  width: 100%;\r\n  background: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\r\n  max-height: 260px;\r\n  overflow-y: auto;\r\n  z-index: 9999;\r\n}\r\n\r\n.search-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  font-size: 14px;\r\n  color: #111827;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.search-item:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n.search-item small {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.no-result {\r\n  padding: 14px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  color: #6b7280;\r\n}\r\n\r\n/* ============================= */\r\n/* INDUSTRY DROPDOWN */\r\n/* ============================= */\r\n.industry-dropdown {\r\n  background: #ffffff;\r\n  border-top: 1px solid #e5e7eb;\r\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.industry-dropdown .container {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\r\n  gap: 12px;\r\n  padding: 18px 0;\r\n}\r\n\r\n.industry-dropdown a {\r\n  font-size: 14px;\r\n  color: #374151;\r\n}\r\n\r\n.industry-dropdown a:hover {\r\n  color: #034EA2;\r\n}\r\n\r\n/* ============================= */\r\n/* MOBILE NAV BAR */\r\n/* ============================= */\r\n.mobile-nav {\r\n  display: none;\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  padding: 10px 0;\r\n}\r\n\r\n.mobile-nav img {\r\n  height: 24px;\r\n  width: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ============================= */\r\n/* MOBILE SEARCH */\r\n/* ============================= */\r\n.mobile-search {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: #ffffff;\r\n  z-index: 9999;\r\n  padding: 20px;\r\n}\r\n\r\n.mobile-search input {\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: 8px;\r\n  border: 1px solid #d1d5db;\r\n  padding: 0 14px;\r\n  font-size: 15px;\r\n}\r\n\r\n/* ============================= */\r\n/* REMOVE BODY SCROLL */\r\n/* ============================= */\r\n.remove-scrolling {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ============================= */\r\n/* RESPONSIVE */\r\n/* ============================= */\r\n@media (max-width: 992px) {\r\n  .top-nav {\r\n    display: none;\r\n  }\r\n\r\n  .search.desktop {\r\n    display: none;\r\n  }\r\n\r\n  .contact-btn {\r\n    display: none;\r\n  }\r\n\r\n  .mobile-nav {\r\n    display: block;\r\n  }\r\n}\r\n\r\n\r\n/* ================= MOBILE HEADER FIX ================= */\r\n\r\n.mobile-actions {\r\n  display: none;\r\n  gap: 14px;\r\n  align-items: center;\r\n}\r\n\r\n.icon-btn {\r\n  height: 26px;\r\n  width: 26px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Hide desktop-only items on mobile */\r\n.desktop-only {\r\n  display: inline-flex;\r\n}\r\n\r\n/* ================= RESPONSIVE ================= */\r\n@media (max-width: 992px) {\r\n  .top-center {\r\n    display: none;\r\n  }\r\n\r\n  .contact-btn.desktop-only {\r\n    display: none;\r\n  }\r\n\r\n  .mobile-actions {\r\n    display: flex;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
